import { render, staticRenderFns } from "./TowersControls.vue?vue&type=template&id=490ce5cf&scoped=true"
import script from "./TowersControls.vue?vue&type=script&lang=js"
export * from "./TowersControls.vue?vue&type=script&lang=js"
import style0 from "./TowersControls.vue?vue&type=style&index=0&id=490ce5cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490ce5cf",
  null
  
)

export default component.exports